import { useTranslation } from 'react-i18next'

import { ScrollableTabs, Text } from '@reveni-io/reveni-ui'

import { contentTabsByMode } from './constants'
import * as Styles from './styles'

const ContentTabs = ({ mode, selectedContentTab, onChangeContentTab }) => {
  const { t } = useTranslation()

  const tabs = contentTabsByMode[mode].map(tab => ({ label: t(tab.label), value: tab.value }))

  return (
    <Styles.Container>
      <Text type="titleS">{t('Cuerpo')}</Text>
      <ScrollableTabs tabs={tabs} value={selectedContentTab} onChange={onChangeContentTab} />
    </Styles.Container>
  )
}

export default ContentTabs
